import React, { useEffect } from "react";
import {
  FaInstagram,
  FaFacebook,
  FaTwitter,
  FaLinkedin,
  FaGithub,
  FaArrowDown,
} from "react-icons/fa";
import { NavLink } from "react-router-dom";

function Artikel3() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <section className="mb-24 mt-28">
      <div className="container relative flex">
        <div className="fixed mx-4  hidden w-full md:left-0 lg:block">
          <div className="">
            <div className="w-1 items-center p-4 pt-0">
              <a
                target="_blank"
                rel="noreferrer"
                href="https://instagram.com/dyy_rul07?igshid=YmMyMTA2M2Y="
              >
                <FaInstagram
                  size={18}
                  className="mx-auto text-primary transition duration-300 hover:-translate-y-1 hover:text-slate-950"
                />
              </a>
            </div>
            <div className="w-1 items-center p-4">
              <a
                target="_blank"
                rel="noreferrer"
                href="https://www.facebook.com/profile.php?id=100078541170035&mibextid=ZbWKwL"
              >
                <FaFacebook
                  size={18}
                  className="mx-auto  text-primary transition duration-300 hover:-translate-y-1 hover:text-slate-950"
                />
              </a>
            </div>
            <div className="w-1 items-center p-4">
              <a
                target="_blank"
                rel="noreferrer"
                href="https://twitter.com/ElhadiKhair?t=tuXc8rDOhZSmBBP90kIgnA&s=09"
              >
                <FaTwitter
                  size={18}
                  className="mx-auto  text-primary transition duration-300 hover:-translate-y-1 hover:text-slate-950"
                />
              </a>
            </div>
            <div className="w-1 items-center p-4">
              <a
                target="_blank"
                rel="noreferrer"
                href="https://www.linkedin.com/in/khairul-hadi-a51598222"
              >
                <FaLinkedin
                  size={18}
                  className="mx-auto  text-primary transition duration-300 hover:-translate-y-1 hover:text-slate-950"
                />
              </a>
            </div>
            <div className="w-1 items-center p-4">
              <a
                target="_blank"
                rel="noreferrer"
                href="https://github.com/dyyrul"
              >
                <FaGithub
                  size={18}
                  className="mx-auto  text-primary transition duration-300 hover:-translate-y-1 hover:text-slate-950"
                />
              </a>
            </div>
          </div>
        </div>
        <div className=" w-full rounded-lg border px-6 py-10 shadow-lg lg:ml-10">
          <h1 className="mb-4 pl-4 text-2xl font-semibold leading-8 text-primary md:text-4xl">
            Exploring Modern Web Programming: Popular Frameworks and Tools in
            2023
          </h1>
          <hr className="mb-5 mt-5" />
          <p className=" md:tex mt-2  text-lg leading-10 text-slate-500 md:leading-[50px]">
            The field of web development is constantly evolving, with new
            technologies and trends emerging each year. In 2023, there are
            several frameworks and tools that are gaining significant popularity
            among web developers. In this article, we will explore some of the
            most in-demand modern web programming frameworks and tools that are
            shaping the web development landscape.
            <h2 className="mb-2 text-lg font-semibold text-slate-800">
              1. React: The Beloved JavaScript Library
            </h2>
            React, developed and maintained by Facebook, has become one of the
            most widely used JavaScript libraries for building user interfaces.
            Its popularity stems from its performance, flexibility, and
            reusability of components. React's virtual DOM (Document Object
            Model) allows for efficient updates and rendering of UI components,
            making it a go-to choice for building modern, dynamic web
            applications.
            <h2 className="mb-2 text-lg font-semibold text-slate-800">
              2. Angular: The Robust TypeScript Framework
            </h2>
            Angular, developed and maintained by Google, is a comprehensive
            JavaScript framework for building web applications. One of its key
            features is the use of TypeScript, a statically-typed superset of
            JavaScript, which provides enhanced tooling, scalability, and
            maintainability. Angular also includes a rich set of features, such
            as dependency injection, two-way data binding, and a powerful
            templating system, making it a preferred choice for complex
            applications.
            <h2 className="mb-2 text-lg font-semibold text-slate-800">
              3. Vue: The Versatile JavaScript Framework
            </h2>
            Vue, developed and maintained by a group of independent developers,
            has gained significant popularity for its simplicity and
            flexibility. Vue is known for its incremental adoption, allowing
            developers to gradually integrate it into existing projects. Vue's
            template syntax is similar to HTML, making it easy to learn and use.
            Vue also provides a range of features, such as reactivity,
            component-based architecture, and a vibrant ecosystem of plugins,
            making it a compelling choice for modern web development.
            <h2 className="mb-2 text-lg font-semibold text-slate-800">
              4. GraphQL: The Modern API Query Language
            </h2>
            GraphQL, developed by Facebook, is a query language for APIs that
            has gained traction in recent years. It provides a more efficient,
            powerful, and flexible alternative to traditional REST APIs. With
            GraphQL, clients can request only the data they need, reducing
            over-fetching and under-fetching of data. GraphQL also enables
            versioning of APIs and allows for real-time updates, making it a
            popular choice for building modern, data-driven web applications.
            <h2 className="mb-2 text-lg font-semibold text-slate-800">
              5. Next.js: The Full-Featured React Framework for Server-Side
              Rendering
            </h2>
            Next.js, developed and maintained by Vercel, is a popular framework
            for building server-rendered React applications. It provides a set
            of features for building production-ready, server-rendered
            applications, such as static site generation, server-side rendering
            (SSR), and API routes. Next.js also includes built-in support for
            performance optimizations, internationalization, and dynamic
            imports, making it a top choice for building modern, scalable web
            applications.
            <h2 className="mb-2 text-lg font-semibold text-slate-800">
              Conclusion:
            </h2>
            In the ever-evolving world of web development, staying updated with
            the latest frameworks and tools is crucial for building modern and
            efficient web applications. In this article, we have explored some
            of the most popular modern web programming frameworks and tools in
            2023, including React, Angular, Vue, GraphQL, and Next.js. By
            leveraging these cutting-edge technologies, web developers can build
            robust, performant, and scalable web applications to meet the
            demands of today's digital landscape.
          </p>
          <div className="w-full px-4">
            <NavLink to="/">
              <button className="mt-3 inline-block w-full rounded-full bg-primary px-8 py-3 text-base font-semibold text-white shadow-lg transition duration-300 ease-in-out hover:-translate-y-1 hover:bg-cyan-300 hover:shadow-lg">
                Back To Home
              </button>
            </NavLink>
          </div>
        </div>

        <div className="mx-4 hidden lg:block">
          <div className="mb-5 rounded-lg border shadow-lg ">
            <h2 className="px-4 py-4">artikel lainnya</h2>
            <hr className="py-4" />
            <div className="animate-bounce pb-6 ">
              <FaArrowDown size={20} className="mx-auto  " />
            </div>
          </div>

          <div class="sm:w-50 mb-10 overflow-hidden rounded-lg bg-white shadow-lg sm:mb-0 md:w-80 lg:w-72">
            <img src="./img/blog3.jpg" alt="Blog 3" class="w-full" />
            <div class="px-6 py-4">
              <div class="mt-6 text-xl font-semibold text-gray-700">
                Mastering Programming: Tips and Strategies for Success in the
                Digital World
              </div>
              <p class="mt-4 text-base text-slate-600">
                Programming has become an increasingly important skill in
                today's digital era. In the rapidly evolving world of
                information.....
              </p>
              <div className="w-full px-4">
                <NavLink to="/artikel1">
                  <button className="mt-3 inline-block w-full rounded-full bg-primary px-8 py-3 text-base font-semibold text-white shadow-lg transition duration-300 ease-in-out hover:-translate-y-1 hover:bg-cyan-300 hover:shadow-lg">
                    Read More
                  </button>
                </NavLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Artikel3;
